import React, { Component } from "react";
import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";
import { FormControl, MenuItem, OutlinedInput, Select } from "@material-ui/core";

import { _ } from "js/vendor";

import Spinner from "js/react/components/Spinner";
import TypographyContainer from "../containers/typography_container";
import { themeOptionsStyls } from "../themeEditor_style";
import FontControl from "./Font/FontControl";
import ThemeSection from "./ThemeSection";

const SpinnerContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;

class Typography extends Component {
    constructor() {
        super();
        this.updateValue = this.updateValue.bind(this);
    }

    updateValue = attribute => event => {
        this.props.update({ [attribute]: event.target.value });
    };

    render() {
        const {
            classes,
            theme,
            originalTheme,
            update,
            fonts,
            fontsFetching,
            orgId,
            isSharedTheme,
            refreshFonts
        } = this.props;

        if (fontsFetching) {
            return <SpinnerContainer><Spinner /></SpinnerContainer>;
        }

        const getCurrentFontStyle = textStyle => {
            const fontId = theme[`font${textStyle}FontId`];
            const fontWeight = theme[`font${textStyle}Weight`];

            // Fonts haven't loaded yet
            if (!fonts.some(font => font.id === fontId)) {
                return null;
            }

            const font = fonts.find(font => font.id === fontId);
            return { ...font.getStyle(fontWeight, false), fontId };
        };

        return (
            <ThemeSection title="Typography">
                <FontControl
                    label="Header"
                    style="Header"
                    update={update}
                    theme={theme}
                    originalTheme={originalTheme}
                    fonts={fonts}
                    currentFontStyle={getCurrentFontStyle("Header")}
                    refreshFonts={refreshFonts}
                    orgId={orgId}
                    isSharedTheme={isSharedTheme}
                />
                <FontControl
                    label="Title"
                    style="Title"
                    update={update}
                    theme={theme}
                    originalTheme={originalTheme}
                    fonts={fonts}
                    currentFontStyle={getCurrentFontStyle("Title")}
                    refreshFonts={refreshFonts}
                    orgId={orgId}
                    isSharedTheme={isSharedTheme}
                />
                <FontControl
                    label="Body"
                    style="Body"
                    update={update}
                    theme={theme}
                    originalTheme={originalTheme}
                    fonts={fonts}
                    currentFontStyle={getCurrentFontStyle("Body")}
                    refreshFonts={refreshFonts}
                    orgId={orgId}
                    isSharedTheme={isSharedTheme}
                />

                <div>
                    <h4>Font Scale</h4>
                    <FormControl style={{ width: 90 }}>
                        <Select
                            value={theme.fontScale}
                            onChange={this.updateValue("fontScale")}
                            input={
                                <OutlinedInput
                                    name="fontScale"
                                    labelWidth={0}
                                    className={classes.whiteTextInput}
                                />
                            }
                        >
                            <MenuItem value={1}>100%</MenuItem>
                            <MenuItem value={1.25}>125%</MenuItem>
                            <MenuItem value={1.5}>150%</MenuItem>
                        </Select>
                    </FormControl>
                </div>

                <div>
                    <h4 style={{ paddingRight: 14 }}>CJK Font</h4>
                    <FormControl style={{ width: 160 }}>
                        <Select
                            value={theme.cjkFont}
                            onChange={this.updateValue("cjkFont")}
                            input={
                                <OutlinedInput
                                    name="cjkFont"
                                    labelWidth={0}
                                    className={classes.whiteTextInput}
                                />
                            }
                        >
                            <MenuItem value="jp">Japanese</MenuItem>
                            <MenuItem value="kr">Korean</MenuItem>
                            <MenuItem value="sc">Simplified Chinese</MenuItem>
                            <MenuItem value="tc">Traditional Chinese</MenuItem>
                        </Select>
                    </FormControl>
                </div>
            </ThemeSection>
        );
    }
}

export default TypographyContainer(withStyles(themeOptionsStyls)(Typography));
